import { render, staticRenderFns } from "./merchant-info.vue?vue&type=template&id=0f89b80b&"
import script from "./merchant-info.vue?vue&type=script&setup=true&lang=ts&"
export * from "./merchant-info.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports